import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { EndpointSpecificFaultCode, Fault, FaultCode } from 'src/app/_models';
import { CacheService } from 'src/app/_services';
import { LoadingComponent } from './_states/loading/loading.component';
import { VerifiedComponent } from './_states/verified/verified.component';
import { ErrorComponent, EmailVerificationError } from './_states/error/error.component';

enum EmailVerificationState {
  Loading = 'Loading',
  Verified = 'Verified',
  Error = 'Error',
}

@Component({
  selector: 'app-email-verification',
  imports: [LoadingComponent, VerifiedComponent, ErrorComponent, RouterLink],
  templateUrl: './email-verification.component.html',
})
export class EmailVerificationComponent {
  email: string = '';
  token: string = '';
  state: EmailVerificationState = EmailVerificationState.Loading;
  error: EmailVerificationError | null = null;

  EmailVerificationState = EmailVerificationState;
  EmailVerificationError = EmailVerificationError;

  //#region Constructor
  constructor(
    private route: ActivatedRoute,
    private cache: CacheService,
  ) {}
  //#endregion

  //#region Lifecycle hooks
  async ngOnInit(): Promise<void> {
    this.token = this.route.snapshot.params['token'];
    this.email = this.route.snapshot.params['email'];

    if (!this.token) {
      this.state = EmailVerificationState.Error;
      this.error = EmailVerificationError.InvalidToken;
    }

    if (!this.email) {
      this.state = EmailVerificationState.Error;
      this.error = EmailVerificationError.InvalidEmail;
      return;
    }

    try {
      await this.cache.sleep(2000);
      await this.cache.verifyEmailByToken(this.token);
      this.state = EmailVerificationState.Verified;
    } catch (error) {
      if (error instanceof Fault) {
        if (error.code === FaultCode.EndpointSpecific) {
          switch (error.inner?.code) {
            case EndpointSpecificFaultCode.MissingEmail:
              this.state = EmailVerificationState.Error;
              this.error = EmailVerificationError.InvalidEmail;
              return;
            case EndpointSpecificFaultCode.MailerBuilderCreationError:
              this.state = EmailVerificationState.Error;
              this.error = EmailVerificationError.NotFound;
              return;
            case EndpointSpecificFaultCode.SendError:
              this.state = EmailVerificationState.Error;
              this.error = EmailVerificationError.InvalidToken;
              return;
            case EndpointSpecificFaultCode.ExistingValidEmail:
              this.state = EmailVerificationState.Error;
              this.error = EmailVerificationError.AlreadyVerified;
              return;
            case EndpointSpecificFaultCode.ExpiredToken:
              this.state = EmailVerificationState.Error;
              this.error = EmailVerificationError.ExpiredToken;
              return;
            default:
              this.state = EmailVerificationState.Error;
              this.error = EmailVerificationError.ExpiredToken;
              return;
          }
        } else {
          this.state = EmailVerificationState.Error;
          this.error = EmailVerificationError.ExpiredToken;
          return;
        }
      } else {
        this.state = EmailVerificationState.Error;
        this.error = EmailVerificationError.InvalidToken;
        return;
      }
    }
  }
  //#endregion
}
